import React, { useCallback } from 'react';
import "../../styles/collections/collection.css";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { firebaseAuth, firebaseFirestore } from "../firebase/firebase_configuration";
import { doc, onSnapshot } from "firebase/firestore";
import { Link } from "react-router-dom";
import { getItem } from "../repositories/movies_and_tvseries";
import NoCollections from "./no_collection";
import AddCollection from "./add_collection";

import addCollectionIcon from "../../images/collections/add_collection_icon.png";
import emptyCollectionImage from "../../images/collections/empty_collection.png";

const Collection = () => {
    const [isShow, setShow] = useState(false);
    const [getUserId, setUserId] = useState("");
    const [getCollections, setCollections] = useState([]);

    const onAdd = () => {
        setShow(true);
    };

    const getAllCollections = useCallback(async () => {
        try {
            const userRef = doc(firebaseFirestore, 'User Collections', getUserId);
            const scription = onSnapshot(userRef, async (docSnapshot) => {
                if (docSnapshot.exists()) {
                    const collectionsData = docSnapshot.data();
                    let collectionsArray = [];
                    Object.keys(collectionsData).forEach((fieldName) => {
                        if (fieldName.startsWith("collection")) {
                            const collection = collectionsData[fieldName];
                            collection.id = fieldName;
                            collectionsArray.push({ ...collection });
                        }
                    });

                    const updatedCollections = await Promise.all(
                        collectionsArray.map(async (collection) => {
                            if (collection.items && collection.items.length > 0) {
                                const itemId = collection.items[0].split("_")[1];
                                const type = collection.items[0].split("_")[0];
                                const details = await getItem({ itemId, type: type === "movie" ? type : "tv" });
                                return { ...collection, image: details.poster_path };
                            }
                            return { ...collection, image: "" };
                        })
                    );

                    const sortedCollections = updatedCollections.sort((a, b) => {
                        if (a.name && b.name) {
                            return a.name.localeCompare(b.name);
                        }
                        return 0;
                    });

                    setCollections(sortedCollections);
                }
            }); 

            return () => scription;
        } catch (error) {
            console.log(error.message); 
        }
    }, [getUserId]);

    const getCardSpace = useCallback(() => {
        if (getCollections.length > 0) {
            const parent = document.getElementById('view_collections_available_grid');
            const parentWidth = parent.offsetWidth;
            const childWidth = window.innerWidth <= 600 ? 110 : 150 + 30;
            const numChildren = Math.floor(parentWidth / childWidth);
            parent.style.gridTemplateColumns = `repeat(${numChildren}, 1fr)`;
        }
    }, [getCollections]);

    useEffect(() => {
        onAuthStateChanged(firebaseAuth, (user) => {
            if (user) {
                setUserId(user.uid);
            }
        });
    }, []);

    useEffect(() => {
        getAllCollections();
    }, [getUserId, getAllCollections]);

    useEffect(() => {
        getCardSpace();
        const handleResize = () => {
            getCardSpace();
        };
    
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [getCollections, getCardSpace]);

    return(
        getCollections.length > 0
        ? <div className="view_collections_screen">
            <p className="view_collections_header">Collections</p>
            <div className="view_collections_available_screen">
                <div id="view_collections_available_grid" className="view_collections_available_grid">
                    <div className="view_add_collection_block_container" onClick={() => onAdd()}>
                        <img className="view_add_collection_block_container_image" src={addCollectionIcon} alt='Add' />
                        <div className="view_add_collection_block_container_column">
                            <p className="view_add_collection_block_container_column_sub">Add a collection</p>
                        </div>
                    </div>

                    {
                        getCollections.map((collection, index) => (
                            <Link className="action_container_sub_home_screen_a" to={`/main_back/collections/${collection.id}/${collection.name.toLowerCase()}`}><div key={index} id="movie_item" className="movie_item">
                                <img
                                    loading='lazy'
                                    src={collection.image === "" || collection.image == null ? emptyCollectionImage : `https://image.tmdb.org/t/p/w500${collection.image}`}
                                    alt={collection.name}
                                    className="movie_poster"
                                />
                                <p className="movie_item_p">{collection.name}</p>
                            </div></Link>
                        ))                        
                    }
                </div>
            </div>
            {isShow && <AddCollection getShow={isShow} setShow={setShow} />}
        </div>

        : <NoCollections/>
    );
};

export default Collection;